import { TimesatsNavne } from '@store/models';

export type RateField = `timesats${1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10}`;
export interface RateColumn { ts: number; name: string; field: RateField; }

export function rateColumns(names: TimesatsNavne[]): RateColumn[] {
    return names.filter(rate => Number.isInteger(rate.ts) && rate.ts >= 1 && rate.ts <= 10 && rate.beskrivelse?.trim())
        .sort((a, b) => a.ts - b.ts)
        .filter((rate, index, all) => index === 0 || all[index - 1].ts !== rate.ts)
        .map(rate => ({ ts: rate.ts, name: rate.beskrivelse.trim(), field: `timesats${rate.ts}` as RateField }));
}
